export default (state, getters) => id => {
    if (!state.list.length) return null;
    return state.list.filter(i => {
        return i.value === id;
    })[0] || {};
}